import { SiteShell } from "@/components/layout/site-shell"

/**
 * A page still being read, for routes without a loading view of their own:
 * the header and footer with nothing between them, instead of the previous
 * page under the new address.
 */
export function PagePending() {
  return <SiteShell>{null}</SiteShell>
}
